import React from 'react';
import { compose, withProps } from 'recompose';

import withScrollElement from 'components/hocs/withScrollElement';

import ResponsiveModal from 'components/ResponsiveModal/component';

const hoc = (WrappedComponent) =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.ref = null;
      this.state = {
        opened: false,
        closeOnBlur: true,
        scrollElement: undefined,
      };
    }

    componentDidMount() {
      if (!this.ref) return;
      this.ref.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
      if (!this.ref) return;
      this.ref.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
      if (['Tab', 'Escape'].includes(e.key)) {
        this.close();
      }
    };

    open = () => {
      this.setState({ opened: true });
    };

    close = () => {
      this.setState({ opened: false, closeOnBlur: true });
    };

    handleRef = (ref) => {
      const { inputRef } = this.props;

      if (inputRef) inputRef(ref);

      this.ref = ref;
    };

    handleBlur = (e) => {
      const { children } = this.props;
      const { closeOnBlur } = this.state;
      const { onBlur } = children.props;

      if (!closeOnBlur) {
        return;
      }

      if (onBlur) onBlur(e);

      this.close();
    };

    handleFocus = (e) => {
      const { children } = this.props;
      const { onFocus } = children.props;
      if (onFocus) onFocus(e);
      this.open();
    };

    handleBlurEnabling = () => {
      if (!!this.ref) this.ref.focus();

      this.setState({ closeOnBlur: true });
    };

    handleBlurDisabling = () => {
      this.setState({ closeOnBlur: false });
    };

    render() {
      const { opened } = this.state;
      return (
        <WrappedComponent
          {...this.props}
          setChildrenRef={this.handleRef}
          opened={opened}
          open={this.open}
          close={this.close}
          listenerElement={this.ref}
          enableBlur={this.handleBlurEnabling}
          disableBlur={this.handleBlurDisabling}
          handleBlur={this.handleBlur}
          handleFocus={this.handleFocus}
        />
      );
    }
  };

const enhance = compose(
  withScrollElement,
  withProps(({ modalRef }) => ({
    ref: modalRef,
  })),
  hoc
);

export default enhance(ResponsiveModal);
